import { call, fork, put, takeEvery } from 'redux-saga/effects';
import NoticeProductApi from '../../../../lib/api/notice/product/NoticeProductApi';
import { setRequestForm, setResponseListForm } from '../../../../lib/common.js';
import toastMsg from '../../../../lib/toastMsg';
import { excelDownLoad } from '../../../../lib/common';
import noticeProductActions from './actions';
import { LIST_PAGINATION_MODEL } from '../../app/models';
import { NOTICE_PRODUCT_LIST_FILTER_OPTION_MODEL, NOTICE_PRODUCT_LIST_SORT_OPTION_MODEL } from './models';
import noticeProductToastMsg from '../../../../constants/service/toastMsg/noticeProductToastMsg';

function* fetchList() {
  /**
   *  [상품 공지사항 리스트] 상품 공지사항 리스트 가져오기
   */
  yield takeEvery(noticeProductActions.GET_NOTICE_PRODUCT_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeProductApi.getNoticeProductList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeProductToastMsg.GET_NOTICE_PRODUCT_LIST_REQUEST_SUCCESS);

        const data = {
          noticeProductList: setResponseListForm(result.data.noticeProductList, result.data.totalCnt, payload),
        };

        yield put({ type: noticeProductActions.GET_NOTICE_PRODUCT_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(noticeProductToastMsg.GET_NOTICE_PRODUCT_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 공지사항 리스트] 상품 공지사항 리스트 엑셀 다운로드 하기
   */
  yield takeEvery(noticeProductActions.GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeProductApi.getNoticeProductExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeProductToastMsg.GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('상품 공지사항 리스트', result.data.productNoticeExcelSheet);
      }
    } catch (error) {
      toastMsg.error(noticeProductToastMsg.GET_NOTICE_PRODUCT_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 공지사항 리스트] 공지사항 삭제 요청하기
   */
  yield takeEvery(noticeProductActions.DELETE_NOTICE_PRODUCT_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeProductApi.deleteNoticeProduct, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeProductToastMsg.DELETE_NOTICE_PRODUCT_REQUEST_SUCCESS);

        /**
         *  삭제 이후 공지사항 리스트를 재조회한다.
         */
        yield put({
          type: noticeProductActions.GET_NOTICE_PRODUCT_LIST_REQUEST,
          payload: {
            filterOption: NOTICE_PRODUCT_LIST_FILTER_OPTION_MODEL,
            sortOption: NOTICE_PRODUCT_LIST_SORT_OPTION_MODEL,
            pagination: LIST_PAGINATION_MODEL,
          },
        });
      }
    } catch (error) {
      toastMsg.error(noticeProductToastMsg.DELETE_NOTICE_PRODUCT_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 공지사항 상세] 상품 공지사항 상세 데이터 요청하기
   */
  yield takeEvery(noticeProductActions.GET_NOTICE_PRODUCT_INFO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeProductApi.getNoticeProductInfo, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeProductToastMsg.GET_NOTICE_PRODUCT_INFO_REQUEST_SUCCESS);

        const data = {
          noticeProductInfo: result.data.noticeProductInfo,
          noticeProductItemListInfo: setResponseListForm(
            result.data.noticeProductItemList,
            result.data.totalCnt,
            payload,
          ),
        };

        yield put({ type: noticeProductActions.GET_NOTICE_PRODUCT_INFO_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(noticeProductToastMsg.GET_NOTICE_PRODUCT_INFO_REQUEST_ERROR, error);
    }
  });

  /**
   *  [상품 공지사항 상세] 상품 공지사항에 등록된 상품 목록 구하기
   */
  yield takeEvery(noticeProductActions.GET_NOTICE_PRODUCT_ITEM_INFO_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(NoticeProductApi.getNoticeProductItemInfo, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(noticeProductToastMsg.GET_NOTICE_PRODUCT_ITEM_INFO_REQUEST_SUCCESS);

        const data = {
          noticeProductItemListInfo: setResponseListForm(
            result.data.noticeProductItemList,
            result.data.totalCnt,
            payload,
          ),
        };

        yield put({ type: noticeProductActions.GET_NOTICE_PRODUCT_ITEM_INFO_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(noticeProductToastMsg.GET_NOTICE_PRODUCT_ITEM_INFO_REQUEST_ERROR, error);
    }
  });
}

export default function* noticeSaga() {
  yield fork(fetchList);
}
